<template>
    <v-menu 
        v-model="menu" 
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <v-btn 
                fab 
                icon 
                style="margin-right: 0px;"
                v-on="on" 
            >
                <v-avatar size="40">
                    <v-img :src="imageUrl">
                        <template v-slot:placeholder>
                            <v-img :src="require('@/assets/perfil_default.png')" />
                        </template>
                    </v-img>
                </v-avatar>
            </v-btn>
        </template>

        <v-window v-model="userWin">
            <v-window-item key="1">
                <v-card 
                    width="320" 
                    class="text-center"
                >
                    <v-row 
                        align="center" 
                        justify="center"
                    >
                        <v-avatar 
                            class="ma-3" 
                            size="150px"
                        >
                            <v-img :src="imageUrl">
                                <template v-slot:placeholder>
                                    <v-img :src="require('@/assets/perfil_default.png')" />
                                </template>
                            </v-img>
                        </v-avatar>
                    </v-row>

                    <v-row 
                        align="center" 
                        justify="center"
                    >
                        <v-card-title 
                            v-if="nombre" 
                            class="pt-0 pb-2"
                        >
                            {{ nombre }} 
                        </v-card-title>
                    </v-row>
                    <v-row justify="center">
                        <v-card-title 
                            v-if="empleadoDatos.Id_Empleado" 
                            class="subtitle-2 pa-0"
                        > 
                            Nue: {{ empleadoDatos.Id_Empleado }}
                        </v-card-title>
                    </v-row>
                    <v-row justify="center">
                        <v-card-title 
                            v-if="empleadoDatos.Email" 
                            class="subtitle-2 py-2 pb-5"
                        > 
                            {{ empleadoDatos.Email }}
                        </v-card-title>
                    </v-row>

                    <v-divider />

                    <v-row 
                        align="center" 
                        class="ma-3" 
                        justify="space-around"
                    >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-if="Es_Alumno" 
                                    color="primary" 
                                    v-on="on"
                                > 
                                    mdi-account-edit
                                </v-icon>
                            </template>
                            <span>Estudiante</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-if="Es_Acad" 
                                    color="primary" 
                                    v-on="on"
                                >
                                    mdi-teach
                                </v-icon>
                            </template>
                            <span>Académico</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-if="Es_Admtvo" 
                                    color="primary" 
                                    v-on="on"
                                >
                                    mdi-account-tie
                                </v-icon>
                            </template>
                            <span>Administrativo</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-if="Es_Inv" 
                                    color="primary" 
                                    v-on="on"
                                >
                                    mdi-account-star
                                </v-icon>
                            </template>
                            <span>Investigador</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-if="Es_Externo" 
                                    color="primary" 
                                    v-on="on"
                                >
                                    mdi-account
                                </v-icon>
                            </template>
                            <span>Externo</span>
                        </v-tooltip>
                    </v-row>
                    <v-divider />

                    <v-card-text class="py-8 px-2">
                        <v-btn 
                            href="https://intraug4.ugto.mx/rh/" 
                            class="mx-1" 
                            small 
                            outlined 
                            color="primary" 
                            elevation="0"
                        >
                            <v-icon 
                                small 
                                color="primary"
                            >
                                mdi-briefcase
                            </v-icon>
                            <h1 
                                class="px-1 subtitle-2" 
                                style="color:#0e345b"
                            >
                                Datos RH
                            </h1>
                        </v-btn>
                        <!-- <v-btn class="mx-1" small outlined color="primary" elevation="0">
                            <v-icon small color="primary">mdi-ambulance</v-icon>
                            <h1 class="px-1 subtitle-2" style="color:#0e345b">Red Medica</h1>

                        </v-btn> -->
                    </v-card-text>

                    <v-divider />
                    <CerrarSesion 
                        :logout="logout" 
                        class="my-1" 
                    />
                </v-card>
            </v-window-item>

            <!-- <v-window-item key="0">

                <v-card width="320" class="text-center">

                    <v-row class="text-left pa-2 ma-0">
                        <v-btn class="xs-6" @click="userWin = 0" small color="primary">
                            <v-icon>keyboard_backspace</v-icon>
                        </v-btn>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="text-center mx-2 py-3" justify="center" align="center">

                        <v-card-title class="subtitle-2 pt-4 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-calendar-account</v-icon>
                                </template>
                                <span>Fecha de Nacimiento</span>
                            </v-tooltip>
                            {{empleadoDatos.fecha_nacimiento}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-4 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-gender-male-female</v-icon>
                                </template>
                                <span>Genero</span>
                            </v-tooltip>
                            {{empleadoDatos.sexo}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-account-box-outline</v-icon>
                                </template>
                                <span>Tipo de Empleado</span>
                            </v-tooltip>
                            {{empleadoDatos.tipo_empleado}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-school</v-icon>
                                </template>
                                <span>Nivel Académico</span>
                            </v-tooltip>
                            {{empleadoDatos.nivel_academico}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-account-clock-outline</v-icon>
                                </template>
                                <span>Antiguedad</span>
                            </v-tooltip>
                            {{empleadoDatos.antiguedad}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-hospital </v-icon>
                                </template>
                                <span>Tiene red médica</span>
                            </v-tooltip>
                            <div v-if="empleadoDatos.tiene_servicio_red_medica === 1">Si</div>
                            <div v-if="empleadoDatos.tiene_servicio_red_medica === 0">No</div>
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-medical-bag</v-icon>
                                </template>
                                <span>Aportación Red Médica</span>
                            </v-tooltip>
                            {{empleadoDatos.aportacion_red_medica}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-water-outline</v-icon>
                                </template>
                                <span>Tipo Sanguineo</span>
                            </v-tooltip>
                            {{empleadoDatos.tipo_sanguineo}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-account-heart-outline</v-icon>
                                </template>
                                <span>Estado Civil</span>
                            </v-tooltip>
                            {{empleadoDatos.estado_civil}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-account-card-details-outline</v-icon>
                                </template>
                                <span>Curp</span>
                            </v-tooltip>
                            {{empleadoDatos.curp}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-4 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="px-1" color="primary" dark v-on="on">mdi-account-card-details-outline</v-icon>
                                </template>
                                <span>Rfc</span>
                            </v-tooltip>
                            {{empleadoDatos.rfc}}
                        </v-card-title>

                        <v-card-title class="subtitle-2 pt-0 pb-0 px-2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <p>
                                        <v-icon class="px-0" color="primary" dark v-on="on">mdi-map-marker</v-icon> {{empleadoDatos.domicilio.calle+", No."}} {{empleadoDatos.domicilio.numero_exterior+","}} {{empleadoDatos.domicilio.colonia+","}} {{empleadoDatos.domicilio.ciudad+","}} {{empleadoDatos.domicilio.estado+","}} {{empleadoDatos.domicilio.pais+","}} {{empleadoDatos.domicilio.estado}} {{"CP: " + empleadoDatos.domicilio.codigo_postal}}
                                    </p>
                                </template>
                                <span>Domicilio</span>
                            </v-tooltip>

                        </v-card-title>

                    </v-row>

                    <v-divider></v-divider>

                    <CerrarSesion class="my-1" :logout="signOutOidc" />
                </v-card>
            </v-window-item> -->
        </v-window>
    </v-menu>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'

import {
    CerrarSesion
} from '@/components/layout'

import { getHashRH } from '@/components/compartidos/hashRH'


export default {
    components: {
        CerrarSesion
    },
    props: {
        nue: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        }
    },
    data: () => ({
        // nue: "02054",
        imageUrl: '',

        userWin: 0,
        menu: false,
        nombre: "",
        Es_Acad: 0,
        Es_Admtvo: 0,
        Es_Alumno: 0,
        Es_Externo: 0,
        Es_Inv: 0,
    }),
    computed: {
        ...mapState(['empleadoDatos']),

        ...mapGetters('oidc', [
            'oidcUser'
        ])
    },
    async created () {
        try {
            const hash = await getHashRH(this.nue);
            this.imageUrl =  `https://recursoshumanos.ugto.mx/api/perfil/v1.1/foto/${hash}/md`; // Ajusta la URL de la imagen según tus necesidades
        } catch (error) {
            console.error('Error generating hash:', error);
        }
    },
    mounted () {
        // console.log("nue", this.nue)
        // console.log(JSON.parse(this.oidcUser.profile))
        this.nombre = this.empleadoDatos.Name
        this.Es_Acad = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Acad)        
        this.Es_Admtvo = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Admtvo)
        this.Es_Alumno = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Alumno)
        this.Es_Externo = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Externo)
        this.Es_Inv = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Inv)

        // console.log(parseInt(JSON.parse(this.oidcUser.profile).Es_Admtvo) )
    },
    methods: {
        ...mapActions({
            signOutOidc: 'oidc/signOutOidc',
            removeOidcUser: 'oidc/removeOidcUser'
        }),
        logout () {
            this.signOutOidc()
            this.removeOidcUser()
        }
    },
}
</script>
